module.exports = __webpack_public_path__ + "static/banner-tablet-2550401179cfef6ea749e4aabc86777b.png";